import { render, staticRenderFns } from "./RelatedInventory.vue?vue&type=template&id=434e2de6&scoped=true"
import script from "./RelatedInventory.vue?vue&type=script&lang=ts"
export * from "./RelatedInventory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434e2de6",
  null
  
)

export default component.exports